import { FeedbackListDrawer } from '@modules/feedback/components/FeedbackListDrawer';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { Box, Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useGetAllTimeDateRange } from 'v2/core/date/date';
import { AggregatePeriod } from 'v2/core/entities';
import { SourceName } from 'v2/core/entities/fields';

interface PreviewFeedbackCardCTAProps {
  sourceDisplayName: string;
  integrationSource: IntegrationSource;
  isDisabled?: boolean;
}

export const PreviewFeedbackCardCTA = ({
  integrationSource,
  sourceDisplayName,
  isDisabled,
}: PreviewFeedbackCardCTAProps) => {
  const [isFeedbackDrawerOpen, setIsFeedbackDrawerOpen] = useState(false);

  const allTimeDateRange = useGetAllTimeDateRange();

  const { source: eqlSource } = integrationSource;

  const queryContainer = useMemo(
    () => ({
      DateRange: allTimeDateRange,
      WhereClause: {
        filter: {
          sourceFilter: {
            sources: [{ name: eqlSource as SourceName }],
          },
        },
      },
      AggregatePeriod: AggregatePeriod.MONTH,
    }),
    [allTimeDateRange, eqlSource],
  );

  if (!eqlSource) {
    return null;
  }

  const handleClick = () => {
    setIsFeedbackDrawerOpen(true);
    trackIntegrationPageEvent({
      eventName:
        'Integrations - Preview Feedback Card Button From Toolbar Clicked',
      integration: {
        integrationType: integrationSource.integrationType,
        channelType: integrationSource.channel.type,
        namespace: integrationSource.namespace,
      },
    });
  };

  return (
    <>
      <FeedbackListDrawer
        open={isFeedbackDrawerOpen}
        onClose={() => setIsFeedbackDrawerOpen(false)}
        queryContainer={queryContainer}
        header={{
          shouldEnableSort: true,
          renderTitle: () => (
            <Typography variant="subtitle2">Feedback for</Typography>
          ),
          renderDescription: () => (
            <Typography variant="subtitle1">
              <Box component="span" color="text.secondary">
                Source:
              </Box>{' '}
              {sourceDisplayName}
            </Typography>
          ),
        }}
      />
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        disabled={isDisabled}
        sx={{ whiteSpace: 'nowrap', minWidth: 'max-content' }}
      >
        Preview Feedback Card
      </Button>
    </>
  );
};
